import { NavigateFunction } from 'react-router-dom';
import { withRouter } from '../../components/hoc/WithRouter';
// import { clearPrivateData } from '../../stores/actions';
// import * as appActions from '../../stores/app/actions';
import { Box, LinearProgress } from '@mui/material';
import { TeamCollections } from '../../stores/jotai/teams/teams';
interface Props {
    location?: {
        query?: {
            nonce?: string;
        }
    }
    navigate?: NavigateFunction
    team?: TeamState;
    cohort?: CohortState;
    org?: OrgState;
    user?: User;
    teams?: TeamCollections;
    cohorts?: CohortsState;
    appState?: AppState;
}
class Forwarder {
  listenToStores = [
    "org",
    "user",
    "team",
    "cohort",
    "teams",
    "cohorts",
    "appState"
  ];

  componentDidMount() {
    const { location } = this.props;

    if (
      Object.keys(this.props?.org)?.length &&
      Object.keys(this.props?.team)?.length
    ) {
      this.handleNavigationChange(location, () => {
        //@ts-ignore
        const cleanedPath = location.pathname.replace("/forward", "");
        this.props.navigate(cleanedPath);
      });
    }
  }

  handleNavigationChange = (location, onDone) => {
    // First we need to fin'd the "location" of this
    const targetOrgID = location?.query?.orgID;
    const targetGroupID = location?.query?.groupID;
    let targetCohortID = location?.query?.cohortID;

    if (targetCohortID === "cohort") {
      // We need to find the cohort
      const foundBaseTeam = this.props?.teamsData[targetGroupID];

      targetCohortID = foundBaseTeam.parentID;
    }

    const currentOrgID = this.props?.org?.id;
    const currentTeamID = this.props?.team?.id;

    if (targetOrgID !== currentOrgID) {
      // First change the org, then change team, then open content
      // appActions.setIsFetching(true);

      /**
       * @description Placeholder for fixing the `getOrg` API and adding the necessary functionality.
       * @date 2024-12-31
       */
      // orgActions.getOrg(targetOrgID, this.props?.user, (response) => {
      //     this.handleFullGroupSelect(targetGroupID, targetCohortID, () => {
      //         onDone();
      //     });
      // });
    } else {
      // Just change the team
      if (targetGroupID !== currentTeamID) {
        this.handleFullGroupSelect(targetGroupID, targetCohortID, () => {
          onDone();
        });
      } else {
        // Where we need to be!
        onDone();
      }
    }
  };

  handleFullGroupSelect = (groupID, cohortID, callback) => {
    // clearPrivateData();
    callback();
  };

  render() {
    return (
      <Box
        anchor={false}
        alignContent="center"
        style={{ paddingTop: "25vh" }}
      >
        <span style={{ display: "block", marginTop: "50px" }}>
          <LinearProgress />
        </span>
      </Box>
    );
  }
}

export default withRouter(Forwarder)